import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import styles from './ResetPassword.module.css';
import { CommonPageStep, ResetPasswordPageStep } from '../..';
import { useAppSelector } from '../../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';
import {
  ResetPasswordElement,
  ResetPasswordElementInterface,
} from '../ResetPasswordElement';

export const MobileView = (): JSX.Element => {
  // REDUX
  const appPageStep = useAppSelector(selectAppPageStep);

  // ELEMENT
  const resetPasswordElement: ResetPasswordElementInterface =
    ResetPasswordElement();
  return (
    <React.Fragment>
      <Box>
        <Box className={styles.mainGroupBox}>
          <Box className={styles.mainGroupTitleBox}>
            <img
              className={styles.loginMainBackButtonIcon}
              id="login-main-back-button"
              alt=""
              src="assets/login/login-main-back-button.svg"
              onClick={() => {
                outsideComponentDispatch(setAppPageStep(CommonPageStep.LOGIN));
              }}
            />
            {appPageStep === ResetPasswordPageStep.RESET ? (
              <span className={styles.mainGroupTitle}>Reset Password</span>
            ) : null}
            {appPageStep === ResetPasswordPageStep.CHANGED ? (
              <span className={styles.mainGroupTitle}>Password Changed!</span>
            ) : null}
          </Box>
          <Box style={{ marginTop: '26px' }}>
            <Box className={styles.mainGroupBoxDescription}>
              {appPageStep === ResetPasswordPageStep.RESET ? (
                <React.Fragment>
                  <span
                    className={styles.mainGroupBoxDescriptionText}
                  >{`Reset your new password.`}</span>
                </React.Fragment>
              ) : null}
              {appPageStep === ResetPasswordPageStep.CHANGED ? (
                <React.Fragment>
                  <span
                    className={styles.mainGroupBoxDescriptionText}
                  >{`Your password has been reset successfully.`}</span>
                </React.Fragment>
              ) : null}
            </Box>
          </Box>
          <Box className={styles.mainGroupPasswordInputBox}>
            {appPageStep === ResetPasswordPageStep.RESET ? (
              <React.Fragment>
                {resetPasswordElement.passwordInputTextfield}
                {resetPasswordElement.passwordRepeatInputTextfield}
              </React.Fragment>
            ) : null}
            {appPageStep === ResetPasswordPageStep.CHANGED ? (
              <React.Fragment>
                {resetPasswordElement.resetPasswordSuccessfulIcon}
              </React.Fragment>
            ) : null}
          </Box>
          {appPageStep === ResetPasswordPageStep.RESET ? (
            <React.Fragment>{resetPasswordElement.submitButton}</React.Fragment>
          ) : null}
          {appPageStep === ResetPasswordPageStep.CHANGED ? (
            <React.Fragment>{resetPasswordElement.loginButton}</React.Fragment>
          ) : null}
        </Box>
      </Box>
      <header className={styles.headerGroup} id="common-navi-bar">
        <img
          className={styles.bbaLogoIcon}
          id="entry-header"
          alt=""
          src="assets/common/bba-logo.svg"
        />
      </header>
    </React.Fragment>
  );
};
